import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteCSRRateModel, CSRRateModel} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GET_CSR_RATE = `${API_URL}/csr-report`

export const service = {
  getCsrRate: (params: ParamsModel) => {
    return axios.get(GET_CSR_RATE, {params})
  },

  addCsrRate: (data: any) => {
    return axios.post(GET_CSR_RATE, data)
  },

  updateCsrRate: (body: CSRRateModel, id: string) => {
    return axios.post(`${GET_CSR_RATE}/${id}`, body)
  },

  deleteCsrRate: (data: DeleteCSRRateModel) => {
    return axios.delete(GET_CSR_RATE, {data})
  },

  enableCsrRate: (data: Array<string>) => {
    const selectedCsrRate = {
      csrReportId: data,
    }
    return axios.patch(`${GET_CSR_RATE}/enable`, selectedCsrRate)
  },

  disableCsrRate: (data: Array<string>) => {
    const selectedCsrRate = {
      csrReportId: data,
    }
    return axios.patch(`${GET_CSR_RATE}/disable`, selectedCsrRate)
  },

  singleEnableCsrRate: (data: Array<string>) => {
    const selectedGallery = {
      csrReportId: [data],
    }
    return axios.patch(`${GET_CSR_RATE}/enable`, selectedGallery)
  },

  singleDisableCsrRate: (data: Array<string>) => {
    const selectedCsrRate = {
      csrReportId: [data],
    }
    return axios.patch(`${GET_CSR_RATE}/disable`, selectedCsrRate)
  },
}
